import React, { useRef } from "react";
import * as c from "./homepageSocialProof.module.scss";
import { RatingCapterra, RatingSoftwareAdvice, RatingG2 } from "./ratings";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import classNames from "classnames";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";

const HomepageSocialProof = ({ logos }) => {
  const Logo = ({ img, alt }) => {
    return (
      <GatsbyImage
        image={getImage(img)}
        imgStyle={{
          objectFit: "contain",
          objectPosition: "center center",
        }}
        alt={alt || ""}
      />
    );
  };

  const container = useRef();

  useGSAP(
    () => {
      gsap.config({
        autoSleep: 60,
      });
      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const isMobile = window.matchMedia("(max-width: 992px)").matches;
      gsap.fromTo(
        ".top-logos",
        { x: "0" },
        {
          x: "-50%",
          duration: reduceMotion ? 0 : isMobile ? 35 : 65,
          ease: "none",
          repeat: reduceMotion ? 0 : -1,
          repeatDelay: 0,
        }
      );
      gsap.fromTo(
        ".bottom-logos",
        { x: "-50%" },
        {
          x: "0%",
          duration: reduceMotion ? 0 : isMobile ? 45 : 85,
          ease: "none",
          repeat: reduceMotion ? 0 : -1,
          repeatDelay: 0,
        }
      );
    },
    { scope: container }
  );

  return (
    <section className={c.container} id="socialproof" ref={container} data-transition="slide-enter-child">
      <div className={c.caption}>
        <h3 className={classNames(c.headline, "h4")}>
          #1 highest-rated by thousands of beauty & wellness professionals
        </h3>
        <div className={c.ratings}>
          <RatingCapterra />
          <RatingSoftwareAdvice />
          <RatingG2 className={c.g2} />
        </div>
      </div>

      <div className={c.marquee}>
        <div className={c.topRow}>
          <div className={classNames("top-logos", c.logorow)}>
            {logos?.map(
              (logo, index) =>
                index <= logos.length / 2 - 1 && (
                  <Logo key={`${logo.description}-${index}`} img={logo} alt={logo.description} />
                )
            )}
            {logos?.map(
              (logo, index) =>
                index <= logos.length / 2 - 1 && (
                  <Logo key={`${logo.description}-${index}-loop`} img={logo} alt={logo.description} />
                )
            )}
          </div>
        </div>
        <div className={c.bottomRow}>
          <div className={classNames("bottom-logos", c.logorow, c.bottomLogos)}>
            {logos?.map(
              (logo, index) =>
                index > logos.length / 2 && (
                  <Logo key={`${logo.description}-bottom-${index}`} img={logo} alt={logo.description} />
                )
            )}
            {logos?.map(
              (logo, index) =>
                index > logos.length / 2 && (
                  <Logo key={`${logo.description}-bottom-${index}-loop`} img={logo} alt={logo.description} />
                )
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export { HomepageSocialProof };
